import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES, APIVERSION} from '../../RequestManagerConstants';

class SeriesListNpvrTask extends AbstractRequestTask {
  constructor({ serieId, seasonId, groupId, language }) {
    super();

    this.groupId = groupId;
    this.serieId = serieId;
    this.seasonId = seasonId;
    this.language = language;
  }

  getUrl() {
    const http = "https://";
    const url = Launcher.get("akamai_mfwk");
    return `${http}${url}/services/recordings/v1/series/list`;
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.api_version;
    if(this.url && !this.url.includes('/v1/')) {
      params.api_version = APIVERSION;
    }
    const extraParams = {
      serie_id: this.serieId,
      season_id: this.seasonId,
      group_id: this.groupId,
      language: this.language,
    };
    return { ...params, ...extraParams };
  }

  getShowModal() {
    return false;
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default SeriesListNpvrTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/npvr/SeriesListNpvrTask.js